import { useState, useEffect, useCallback, useRef } from "react";
import {
  delegates_white_icon,
  add_icon,
  edit_icon,
  right_arrow_icon,
  delete_icon,
  eye_regular,
} from "../../assets/icons/icons";
import { message } from "antd";
import {
  Container,
  ThemeTable,
  ThemeButton,
  DelegateDrawer,
  ThemeInput,
} from "../../components/components";
import { user, userFemale } from "../../assets/images/images";
import { NavLink } from "react-router-dom";
import {
  useGetUsersQuery,
  useRegisterUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useLazyGetUserStatsQuery,
} from "../../services/auth";
import ShowStatsModal from "../../components/showStatsModal/showStatsModal";
import { debounce } from "lodash";
import { useLazyGetUserEventsAndMeetingsQuery } from "../../services/newMeeting";
import { useImportDelegatesMutation } from "../../services/attendees";
import Papa from "papaparse";
import * as Yup from "yup";

const Delegates = () => {
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [mode, setMode] = useState("create");
  const [editID, setEditID] = useState("");
  const [userID, setUserID] = useState("");
  const [search, setSearch] = useState("");
  const [showPassword, setShowPassword] = useState(false)
  const [formErrors, setFormErrors] = useState({});

  const [deleteUser, { isLoading: deleting }] = useDeleteUserMutation();
  const { data, error, isLoading, refetch } = useGetUsersQuery({
    currentPage,
    resultPerPage,
    userType: "delegate",
    search,
  });
  const [registerUser, { isLoading: regestiring }] = useRegisterUserMutation();
  const [updateUser, { isLoading: updating }] = useUpdateUserMutation();
  const [getUserStats] = useLazyGetUserStatsQuery();

  const [delegateStats, setDelegateStats] = useState(null);
  const [showDelegateStatsModal, setShowDelegateStatsModal] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const validationSchema = Yup.object({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().required("Password is required"),
    gender: Yup.string().required("Gender is required"),

    metadata: Yup.object().shape({
      delegate_details: Yup.object().shape({
        phone: Yup.string()
          .required("Phone number is required")
        
      }),
    }),
  });
  const [
    getUserEventsAndMeetings,
    { isLoading: getUserEventsAndMeetingsLoading },
  ] = useLazyGetUserEventsAndMeetingsQuery();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    picture: "",
    user_type: "delegate",
    metadata: {
      delegate_details: {
        company: "",
        position: "",
        country: "",
        post_code: "",
        fax: "",
        phone: "",
        mobile: "",
      },
      atendee_details: {
        name: "",
        position: "",
        email_and_tel: "",
        company: "",
      },
      extra_details: {
        name: "",
        position: "",
        line_manager: "",
        priorities: "",
        intrest_list: "",
        focused_therapeutic_area: "",
        indutrial_sector: [],
        ap_budget: null,
        scope_for_resposibility: null,
        products_and_services: null,
      },
    },
  });

  const validateForm = async (formData) => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });
      return null; // No validation errors
    } catch (err) {
      const errors = {};
      err.inner.forEach((error) => {
        errors[error.path] = error.message;
      });
      return errors;
    }
  };


  const [image, setImage] = useState("");
  const [importDelegates, { isLoading: importingDelegates }] =
    useImportDelegatesMutation();
  const delegateFileInputRef = useRef(null);

  const handleDownloadDelegateTemplate = () => {
    const headers = [
      "first_name",
      "last_name",
      "email",
      "password",
      "gender",
      "phone",
      "company",
      "position",
      "website",
      "linkedIn",
      "priorities",
      "interest_list",
      "industrial_sector",
      "annual_budget",
      "scope_for_responsibility",
      "products_and_services",
      "focused_therapeutic_area",
    ];
    const sampleRow = [
      "John",
      "Doe",
      "john.doe@example.com",
      "Pass@123",
      "male",
      "+441234567890",
      "ACME Pharma",
      "Head of R&D",
      "https://www.acme-pharma.com",
      "https://www.linkedin.com/in/johndoe",
      "Improve oncology pipeline",
      "Oncology, Immunology",
      "Pharma, Biotech",
      "100k-250k",
      "R&D,Budget",
      "Lab equipment,Software",
      "Oncology focus",
    ];
    const csv = Papa.unparse([headers, sampleRow], { header: false });
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "delegates_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleImportDelegatesCSV = (file) => {
    if (!file) return;
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (result) => {
        try {
          const rows = (result.data || []).filter((r) => r.email);
          if (!rows.length) {
            message.warning("No valid rows found in delegate CSV.");
            return;
          }
          const res = await importDelegates({ eventId: null, rows }).unwrap();
          message.success(
            `Delegates import completed. Inserted: ${res.inserted}, Skipped: ${res.skipped}`
          );
          refetch();
        } catch (err) {
          console.error(err);
          message.error(
            err?.data?.message || "Failed to import delegates from CSV."
          );
        } finally {
          if (delegateFileInputRef.current) {
            delegateFileInputRef.current.value = "";
          }
        }
      },
      error: () => {
        message.error("Failed to parse delegate CSV file.");
        if (delegateFileInputRef.current) {
          delegateFileInputRef.current.value = "";
        }
      },
    });
  };

  const handleSearchChange = useCallback(
    debounce((value) => {
      setCurrentPage(1);
      setSearch(value);
      refetch(); // Trigger API call when user stops typing
    }, 300), // Adjust the debounce delay as needed
    []
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    handleSearchChange(value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState)
  }

  useEffect(() => {
    setTotal(data?.users?.total || 0);
  }, [data]);

  const onClose = () => {
    setOpen(false);
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      picture: "",
      user_type: "delegate",
      metadata: {
        delegate_details: {
          company: "",
          position: "",
          country: "",
          post_code: "",
          fax: "",
          phone: "",
          mobile: "",
        },
        atendee_details: {
          name: "",
          position: "",
          email_and_tel: "",
          company: "",
        },
        extra_details: {
          name: "",
          position: "",
          line_manager: "",
          priorities: "",
          intrest_list: "",
          focused_therapeutic_area: "",
          indutrial_sector: [],
          ap_budget: null,
          scope_for_resposibility: null,
          products_and_services: null,
        },
      },
    });
    setImage("");
    setMode("create");
  };

  const onSubmit = async () => {
    const errors = await validateForm(formData);
    if (errors) {
      setFormErrors(errors); // Set validation errors to state
      return; // Don't proceed if there are validation errors
    }

    let response;
    if (mode === "create") {
      response = await registerUser(formData);
    } else {
      response = await updateUser({ id: editID, body: formData });
    }

    if (response?.data?.status === 200) {
      message.success(
        `Delegate ${mode === "create" ? "registered" : "updated"} successfully.`
      );
      onClose();
      refetch();
      return;
    }
    message.error(response?.error?.data?.message || "Something went wrong");
  };


  const onEdit = (data) => {
    setEditID(data?._id);
    setFormData(data);
    setImage(data?.picture);
    setMode("edit");
    setOpen(true);
  };

  const seeDetail = async (data) => {
    const meetingsAndEvents = await getUserEventsAndMeetings(data._id);
    console.log(meetingsAndEvents, "meetingsAndEvents");

    if (meetingsAndEvents?.data?.status === 200) {
      setDelegateStats(meetingsAndEvents?.data?.data);
      console.log(meetingsAndEvents?.data?.data);
      setUserInfo(data);
      setShowDelegateStatsModal(true);
    }
  };

  const onDelete = async (data) => {
    try {
      const res = await deleteUser({ id: data._id });
      if (res.data.status === 200) {
        message.success(res.data.message);
        refetch();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const columns = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      render: (data, _, index) => (
        <p className="text-center font-medium">{index + 1}</p>
      ),
    },
    {
      title: "Picture",
      dataIndex: "picture",
      key: "picture",
      render: (picture, data) => (
        <div className="flex justify-center">
          <img
            className="rounded-full object-cover"
            src={picture || (data.gender === "male" ? user : userFemale)}
            alt=""
            style={{ height: "66px", width: "66px" }}
          />
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
      render: (_, data) => (
        <p className="text-center font-medium">{`${data.first_name} ${data.last_name}`}</p>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (email) => <p className="text-center font-medium">{email}</p>,
    },
    {
      title: "Password",
      dataIndex: "password",
      key: "password",
      render: (password) => (
        <div className="flex items-center justify-between ">
          <p className="font-medium">{showPassword ? password : <span className="text-2xl">••••••••••••••••</span>}</p>
          <span className="mx-2 cursor-pointer" >
            <img src={eye_regular} alt="" width={22} height={15} onClick={togglePasswordVisibility} />
          </span>
        </div>

      ),
    },
    {
      title: "In Action",
      dataIndex: "_id",
      key: "_id",
      width: "10%",
      render: (text, data) => (
        <span className="flex justify-center items-center">
          <span className="mx-2 cursor-pointer" onClick={() => onEdit(data)}>
            <img src={edit_icon} alt="" width="22px" />
          </span>
          <span className="mx-2 cursor-pointer" onClick={() => seeDetail(data)}>
            <img src={eye_regular} alt="" width="22px" />
          </span>

          <span className="mx-2 cursor-pointer" onClick={() => onDelete(data)}>
            <img src={delete_icon} alt="" width="22px" />
          </span>
        </span>
      ),
    },
  ];

  return (
    <Container
      selected={"4"}
      header={
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="bg-primary h-9 w-9 rounded-full flex justify-center items-center">
              <img src={delegates_white_icon} width={17} height={17} alt="" />
            </div>
            <p className="ml-2 font-semibold text-2xl">Delegates</p>
          </div>
          <div className="flex items-center">
            <ThemeInput
              onChange={handleInputChange}
              className="mb-1"
              placeholder="Search delegates"
            />
            <ThemeButton
              className={"ml-3"}
              onClick={handleDownloadDelegateTemplate}
              content={
                <div className="flex items-center">
                  <p className="ml-2">Template</p>
                </div>
              }
            />
            <ThemeButton
              className={"ml-3"}
              onClick={() => delegateFileInputRef.current?.click()}
              disabled={importingDelegates}
              content={
                <div className="flex items-center">
                  <p className="ml-2">
                    {importingDelegates ? "Importing..." : "Import CSV"}
                  </p>
                </div>
              }
            />
            <ThemeButton
              className={"ml-3"}
              content={
                <div className="flex items-center">
                  <img src={add_icon} alt="" width={18} height={18} />
                  <p className="ml-2">Add Delegates</p>
                </div>
              }
              onClick={() => setOpen(true)}
            />
          </div>
        </div>
      }
    >
      <DelegateDrawer
        open={open}
        onClose={onClose}
        btnTxt={mode === "create" ? "Add Delegate" : "Update Delegate"}
        addIcon={mode === "create" ? add_icon : null}
        onSubmit={onSubmit}
        isLoading={mode === "create" ? regestiring : updating}
        formData={formData}
        setFormData={(e) => setFormData(e)}
        image={image}
        setImage={(e) => setImage(e)}
        mode={mode}
        formErrors={formErrors}
      />

      <ThemeTable
        pagination={{ total, setCurrentPage, setResultPerPage }}
        columns={columns}
        data={data?.users?.data || []}
      />

      <ShowStatsModal
        isModalOpen={showDelegateStatsModal}
        stats={delegateStats}
        user={userInfo}
        onClose={() => setShowDelegateStatsModal(false)}
      />
      <input
        type="file"
        accept=".csv"
        ref={delegateFileInputRef}
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            handleImportDelegatesCSV(file);
          }
        }}
      />
    </Container>
  );
};

export default Delegates;
